export default __webpack_public_path__ + "static/media/Jupiter.529cdbe0.png";